import { ReactElement, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getUserProfile } from '~/helpers/userProfile';
import { FilterProvider } from './contexts/FilterContext';
import { OverviewLayout } from './Layout';

export function Overview(): ReactElement {
  const [profile] = useState(getUserProfile());
  const history = useHistory();

  useEffect(() => {
    const isAllowClientOverview = !profile.permissions.isInstaller;
    if (isAllowClientOverview || profile.manageAllClients || profile.manageMultipleClients) return;
    history.push('/analise/unidades');
  }, []);

  return (
    <FilterProvider>
      <OverviewLayout />
    </FilterProvider>
  );
}
